import { render, staticRenderFns } from "./BarcodeCompanySelect.vue?vue&type=template&id=27822d78"
import script from "./BarcodeCompanySelect.vue?vue&type=script&lang=ts"
export * from "./BarcodeCompanySelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports